<div class="imagebucket-picker">
  <div class="imagebucket-picker__header">
    <span class="imagebucket-picker__title">Pick from site gallery</span>
    <span class="imagebucket-picker__hint">Files in <code>assets/imagebucket</code></span>
  </div>
  <div class="imagebucket-picker__modes" role="group" aria-label="How to use the selected image">
    <button
      mat-stroked-button
      type="button"
      [color]="mode === 'cover' ? 'primary' : undefined"
      (click)="mode = 'cover'"
    >
      Cover
    </button>
    <button
      mat-stroked-button
      type="button"
      [color]="mode === 'gallery' ? 'primary' : undefined"
      (click)="mode = 'gallery'"
    >
      Add to gallery
    </button>
  </div>
  <p class="imagebucket-picker__help">
    @if (mode === 'cover') {
      Sets <strong>Cover image URL</strong> (card + first carousel slide).
    } @else {
      Appends to <strong>Gallery image URLs</strong> (carousel); skips duplicates.
    }
  </p>
  <div class="imagebucket-picker__grid">
    @for (opt of options; track opt.url) {
      <button
        type="button"
        class="imagebucket-picker__tile"
        [ngClass]="tileClass(opt)"
        (click)="emitPick(opt.url)"
        [attr.aria-label]="'Use ' + opt.label + ' as ' + (mode === 'cover' ? 'cover' : 'gallery image')"
      >
        <span class="imagebucket-picker__thumb-wrap">
          <img [src]="opt.url" [alt]="''" loading="lazy" decoding="async" />
        </span>
        <span class="imagebucket-picker__caption">{{ opt.label }}</span>
      </button>
    }
  </div>
</div>
